<div style="visibility: hidden; height: 0; width: 0;">
  <svg width="72" height="72" xmlns="http:/*                   */
    <defs>
      <linearGradient id="bunt" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" style="stop-color:#7e3906; stop-opacity:1" />
        <stop offset="10%" style="stop-color:#7e3906; stop-opacity:1" />
        <stop offset="11%" style="stop-color:#ff889e; stop-opacity:1" />
        <stop offset="23%" style="stop-color:#ff889e; stop-opacity:1" />
        <stop offset="24%" style="stop-color:#8d0083; stop-opacity:1" />
        <stop offset="37%" style="stop-color:#8d0083; stop-opacity:1" />
        <stop offset="38%" style="stop-color:#198504; stop-opacity:1" />
        <stop offset="48.5%" style="stop-color:#198504; stop-opacity:1" />
        <stop offset="49.5%" style="stop-color:#334982; stop-opacity:1" />
        <stop offset="63%" style="stop-color:#334982; stop-opacity:1" />
        <stop offset="64%" style="stop-color:#ffd229; stop-opacity:1" />
        <stop offset="76%" style="stop-color:#ffd229; stop-opacity:1" />
        <stop offset="77%" style="stop-color:#ee9201; stop-opacity:1" />
        <stop offset="90%" style="stop-color:#ee9201; stop-opacity:1" />
        <stop offset="91%" style="stop-color:#d52b1e; stop-opacity:1" />
        <stop offset="100%" style="stop-color:#d52b1e; stop-opacity:1" />
      </linearGradient>
      <linearGradient id="silberfarben" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="17%" style="stop-color:#888a87; stop-opacity:1" />
        <stop offset="54%" style="stop-color:#e9ebe7; stop-opacity:1" />
        <stop offset="70%" style="stop-color:#e9ebe7; stop-opacity:1" />
        <stop offset="95%" style="stop-color:#888a87; stop-opacity:1" />
      </linearGradient>
      <linearGradient id="goldfarben" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" style="stop-color:#aa5b00; stop-opacity:1" />
        <stop offset="17%" style="stop-color:#994700; stop-opacity:1" />
        <stop offset="54%" style="stop-color:#ffe284; stop-opacity:1" />
        <stop offset="70%" style="stop-color:#ffe284; stop-opacity:1" />
        <stop offset="95%" style="stop-color:#994700; stop-opacity:1" />
      </linearGradient>
    </defs>
  </svg>
</div>
